
import { startupStateReducer, uiReducer, customerReducer, journeyReducer, valuationReducer } from '../reducers';
import { JStore } from "../journeys/context/interfaces"
import userReducer from '../reducers/userReducer';
import actionTypeConstants from './actionTypeConstants';
import notificationReducer from '../reducers/notificationReducer';

export interface NewJStore {
  startupState: JStore,
  ui: JStore,
  customerInfo: JStore,
  journeyInfo: JStore,
  userInfo: JStore,
  valuationInfo: JStore,
  notifications: any[],
  [key: string]: string | number | boolean | object;
}

export function getInitialState() {

  const INIT_ACTION = {
    type: actionTypeConstants.INIT
  };

  return {
    startupState: startupStateReducer({} as JStore, INIT_ACTION),
    ui: uiReducer({} as JStore, INIT_ACTION),
    userInfo: userReducer({} as JStore, INIT_ACTION),
    customerInfo: customerReducer({} as JStore, INIT_ACTION),
    journeyInfo: journeyReducer({} as JStore, INIT_ACTION),
    valuationInfo: valuationReducer({} as JStore, INIT_ACTION),
    notifications: notificationReducer([] as any[], INIT_ACTION)
  };

}